import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ConversationStarterService } from 'src/app/service/http-services/conversation-starter.service';

@Component({
  selector: 'app-conversation-starter',
  templateUrl: './conversation-starter.component.html',
  styleUrls: ['./conversation-starter.component.css']
})
export class ConversationStarterComponent implements OnInit {

  @Output() question: string = "";

  @Output() start = new EventEmitter<any>();
  

  constructor(
    private conversationSrvice: ConversationStarterService
  ) { }

  ngOnInit(): void {
  }

  getQuestion(){
    this.conversationSrvice.getConversationStarterquestion().subscribe(q => this.question=q);
  }

  onClickStart(event: any){
    this.start.emit(event);
  }

}
